module.exports = __webpack_public_path__ + "static/media/pinksappdp.f61fcd2b.jpg";